const STATUS_LABELS = {
  changed: "Ordre modifié",
  unchanged: "Ordre inchangé",
  unavailable: "Comparaison non disponible",
};

function isRow(row, index) {
  return row && row.position === index + 1
    && ["loading", "delivery"].includes(row.step_type)
    && Array.isArray(row.order_ids) && row.order_ids.length > 0
    && row.order_ids.every((id) => typeof id === "string" && id.trim())
    && Array.isArray(row.other_positions)
    && row.other_positions.every((position) => Number.isInteger(position) && position > 0)
    && ["unchanged", "moved", "added", "removed", "regrouped"].includes(row.change);
}

export function formatTruckSequenceChange(row, side) {
  if (row.change === "added") return "Étape ajoutée";
  if (row.change === "removed") return "Étape retirée";
  if (row.change === "unchanged") return "";
  const before = side === "before" ? [row.position] : row.other_positions;
  const after = side === "after" ? [row.position] : row.other_positions;
  const positions = `${before.join(", ")} → ${after.join(", ")}`;
  return row.change === "regrouped"
    ? `Regroupement modifié · positions ${positions}`
    : `position ${positions}`;
}

export function formatTruckSequenceStep(row) {
  const type = row.step_type === "loading" ? "Chargement" : "Livraison";
  const labels = Array.isArray(row.order_labels) && row.order_labels.length === row.order_ids.length
    ? row.order_labels.map((label, index) => label || row.order_ids[index])
    : row.order_ids;
  return [type, labels.join(" + "), row.client_label].filter(Boolean).join(" · ");
}

export function resolveTruckSequenceComparison(item = {}) {
  const diagnostics = item.diagnostics || {};
  const raw = diagnostics.truck_sequence_comparison;
  const action = item.operationAction || diagnostics.operation_action || item.action || diagnostics.action;
  if (action !== "optimize_truck_routes" && !raw) return null;
  const unavailable = { status: "unavailable", label: STATUS_LABELS.unavailable, before: [], after: [] };
  if (["failed", "refused", "cancelled", "awaiting_confirmation"].includes(item.status)
    || !raw || !["changed", "unchanged"].includes(raw.status)
    || !Array.isArray(raw.before) || !Array.isArray(raw.after)
    || !raw.before.every(isRow) || !raw.after.every(isRow)
    || raw.before.some((row) => row.other_positions.some((position) => position > raw.after.length))
    || raw.after.some((row) => row.other_positions.some((position) => position > raw.before.length))) {
    return unavailable;
  }
  return { ...raw, label: STATUS_LABELS[raw.status] };
}

export function buildTruckSequenceComparisonCopyText(item) {
  const comparison = resolveTruckSequenceComparison(item);
  if (!comparison) return "";
  const sections = [`## Ordre des chargements et livraisons\n${comparison.label}`];
  if (comparison.status === "unavailable") return sections[0];
  for (const [side, title] of [["before", "Avant optimisation"], ["after", "Après optimisation"]]) {
    const lines = comparison[side].map((row) => {
      const change = formatTruckSequenceChange(row, side);
      return `${row.position}. ${formatTruckSequenceStep(row)}${row.is_preloaded_previous_day ? " · Chargé la veille" : ""}${change ? ` — ${change}` : ""}`;
    });
    sections.push(`### ${title}\n${lines.join("\n") || "Aucune étape"}`);
  }
  sections.push(`### Diagnostic de séquence\n${JSON.stringify(item.diagnostics.truck_sequence_comparison, null, 2)}`);
  return sections.join("\n\n");
}
